export const PushTabOptions = [
  { value: 'happy_tabs', label: 'HappyTabs' },
  { value: 'tabulary', label: 'Tabulary' },
  { value: 'awards', label: 'Awards' },
  { value: 'account', label: 'Account' },
];

export const PushActionHappyTabsOptions = [
  { value: 'unflip', label: 'Unflipped' },
  { value: 'flip', label: 'Flipped' },
  { value: 'open', label: 'Opened' },
  { value: 'compose', label: 'Straight to compose' },
];

export const PushActionTabularyTabsOptions = [
  { value: 'state_mini', label: 'Mini' },
  { value: 'state_maxi', label: 'Maxi' },
];

export const PushCardOptions = [
  { value: 'random', label: 'Random' },
  { value: 'mindfulness', label: 'Mindfulness' },
  { value: 'affirmation', label: 'Affirmation' },
  { value: 'gratitude', label: 'Gratitude' },
  { value: 'intention', label: 'Intention' },
  { value: 'kudos', label: 'Kudos' },
];

export const getLabelByValueFromOptions = (
  value: string | number | null | undefined,
  options: ReadonlyArray<{ value: string; label: string }>,
): string | void => {
  if (typeof value !== 'string') {
    return;
  }

  const foundOption = options.find((option) => option.value === value);

  if (foundOption) {
    return foundOption.label;
  }

  return;
};
